import { useRef } from 'react';
import { Description, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { CircleAlert, Trash2 } from 'lucide-react';
import './ProjectDeleteDialog.css';

export default function ProjectDeleteDialog({ open, onClose, onConfirm, title, children, deleting, pendingLabel, error }) {
  const cancelRef = useRef(null);

  return (
    <Dialog open={open} onClose={onClose} initialFocus={cancelRef} className="project-delete-dialog" role="alertdialog">
      <DialogBackdrop className="project-delete-dialog__backdrop" />
      <div className="project-delete-dialog__position">
        <DialogPanel className="project-delete-dialog__panel" aria-busy={deleting}>
          <div className="project-delete-dialog__heading"><Trash2 size={18} aria-hidden="true" /><DialogTitle>{title}</DialogTitle></div>
          <Description className="project-delete-dialog__description">{children}</Description>
          <Description className="project-delete-dialog__warning"><CircleAlert size={15} aria-hidden="true" />此操作不可恢复，请谨慎操作。</Description>
          {error && <p className="project-delete-dialog__error" role="alert">{error}</p>}
          <div className="project-delete-dialog__actions">
            <span role="status">{deleting ? pendingLabel : ''}</span>
            <button type="button" ref={cancelRef} disabled={deleting} onClick={onClose}>取消</button>
            <button type="button" className="is-danger" disabled={deleting} onClick={onConfirm}>{deleting ? '正在删除…' : '确认删除'}</button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
